import { fg } from '@atlassian/jira-feature-gating';
import {
	APP_USER,
	ATLASSIAN_ACCOUNT_USER,
	CUSTOMER_USER,
	UNKNOWN_USER,
} from '@atlassian/jira-shared-types/src/rest/jira/user.tsx';

// @ts-expect-error TODO JPX-157
const getAccountType = (objectType) => {
	switch (objectType) {
		case 'AtlassianAccountUser':
			return ATLASSIAN_ACCOUNT_USER;
		case 'CustomerUser':
			return CUSTOMER_USER;
		case 'AppUser':
			return APP_USER;
		default:
			return UNKNOWN_USER;
	}
};

// @ts-expect-error TODO JPX-157
const generateAvatarUrls = (url) => ({
	'16x16': url,
	'24x24': url,
	'32x32': url,
	'48x48': url,
});

type AvatarData = {
	avatarUrl?: string;
	avatarUrls: ReturnType<typeof generateAvatarUrls>;
};

// @ts-expect-error TODO JPX-157
export const transformJiraUserToLegacyServerUser = (user) => {
	if (!user) return null;

	const userOptionalKeysMap = {
		emailAddress: 'email',
		locale: 'locale',
		timeZone: 'zoneinfo',
	};

	const optionalValues = {};

	Object.entries(userOptionalKeysMap).forEach(([key, aggKey]) => {
		const aggValue = user[aggKey];

		if (aggValue !== undefined && aggValue !== null) {
			// @ts-expect-error TODO JPX-157
			optionalValues[key] = aggValue;
		}
	});

	// legacy user always assumes that avatarUrls are generated, even if it is undefined
	const avatars =
		user.picture != null
			? {
					avatarUrl: user.picture,
					avatarUrls: generateAvatarUrls(user.picture),
				}
			: { avatarUrls: fg('remove-user-rest-api') ? generateAvatarUrls(user.picture) : undefined };

	return {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		...(avatars as AvatarData),
		...optionalValues,
		accountId: user.accountId,
		accountType: getAccountType(user.__typename),
		active: user.accountStatus === 'active',
		displayName: user.name,
		appType: user?.appType ?? undefined,
	};
};
